import { createContext } from 'react'

// Lets a page hide the Intercom launcher for a while, without deciding on which routes it shows.
// The launcher is drawn above everything, so over a full-viewport SCORM course it would cover the
// course's own controls — typically its "next" button, bottom right.
export const LauncherContext = createContext({
  setLauncherSuppressed: (_suppressed: boolean) => {},
})
